import React from "react";
import SmsIcon from "@material-ui/icons/Sms";
import {MailRounded} from "@material-ui/icons";
import {TwoFactorMethodType} from "@evennt-tech/api-v2-external";
import PasskeyIcon from "view/images/PasskeyIcon";
import QrCodeIcon from "view/images/QrCodeIcon";

export const TWO_FACTOR_METHOD_LABEL: Record<TwoFactorMethodType, string> = {
  passkey: "PassKey",
  totp: "Authenticator app",
  sms: "Phone number (SMS)",
  email: "Email",
};

export const TWO_FACTOR_METHOD_LABEL_KEY: Record<
  TwoFactorMethodType,
  string
> = {
  passkey: "common.two_factor.method.passkey",
  totp: "common.two_factor.method.authenticator",
  sms: "common.two_factor.method.sms",
  email: "common.two_factor.method.email",
};

export const renderTwoFactorMethodIcon = (
  method: TwoFactorMethodType
): React.ReactNode => {
  switch (method) {
    case "sms":
      return <SmsIcon color="primary" />;
    case "totp":
      return <QrCodeIcon />;
    case "passkey":
      return <PasskeyIcon />;
    case "email":
      return <MailRounded color="primary" />;
    default:
      return null;
  }
};
